import { Component, Inject } from '@angular/core';
import { EngagementService } from '../engagement.service';

@Component({
  selector: 'app-engagement-wrapper',
  templateUrl: './engagement-wrapper.component.html',
  styleUrls: ['./engagement-wrapper.component.scss'],
})
export class EngagementWrapperComponent {
  constructor(public engagementService: EngagementService, @Inject('$stateParams') $stateParams: any) {
    if ($stateParams) {
      const { userExternalId, siteId } = $stateParams;
      if (userExternalId && siteId) {
        engagementService.initContext(+siteId, userExternalId);
      }
    }
    const rootElement = document.querySelector('.alc-v3-content');
    if (rootElement?.classList) {
      rootElement.classList.remove('alc-v3-content');
      rootElement.classList.add('alc-angular-task-process-page');
    }
  }
}
